import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet-async';
import { forwardRef } from 'react';
// @mui
import { Box, Button, Paper, Stack, styled, Typography } from '@mui/material';
import { BreadCrumbs } from './Breadcrumbs';
import { useNavigate } from 'react-router';
import { MdArrowBackIosNew } from 'react-icons/md';

// ----------------------------------------------------------------------

export const Page = forwardRef(({ children, title = '', meta, paths, ...other }, ref) => (
  <>
    <Helmet>
      <title>{`${title} | بیز آکادمی`}</title>
      {meta}
    </Helmet>

    {paths?.length > 0 && <BreadCrumbs paths={paths} />}

    <Box ref={ref} {...other}>
      <StyledPaper sx={{ my: 3 }}>{children}</StyledPaper>
    </Box>
  </>
));

export const PageTitle = ({ title, size, withBackButton = false }) => {
  const navigate = useNavigate();

  function handleBack() {
    navigate(-1);
  }

  return (
    <Stack flexDirection={'row'} justifyContent={'space-between'} mb={withBackButton ? 3 : 0}>
      <Typography fontSize={!size ? 20 : size} fontWeight={700} sx={{ mb: 3 }}>
        {title}
      </Typography>

      {withBackButton && (
        <Button size="small" variant="text" onClick={handleBack} endIcon={<MdArrowBackIosNew />}>
          بازگشت
        </Button>
      )}
    </Stack>
  );
};

const StyledPaper = styled(Paper)(() => ({
  background: '#FFFFFF',
  borderRadius: '16px',
  border: '1px solid #F1F3F4',
  width: 'min(100%,98vw)',
  minHeight: 698,
  height: '100%',
  padding: '24px',
  boxShadow: '0px 12px 22px rgba(0, 0, 0, 0.09)',
  margin: '0 auto',
}));

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string,
  meta: PropTypes.node,
  paths: PropTypes.array,
};
